<template>
  <div id='CallOverlay' @click='hide()' class="modal fade">
    <div id="content" class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <p class="modal__title">相談員に相談する</p>
        <p>
          株式会社ソナエルでは、専門知識を兼ね備えた相談員が、お客様にとって最善のご提案をいたします。<br>
          気になる施設があれば、お気軽にご相談ください。
        </p>
        <div class="topicContainer">
          <div class="topicContainer__title">
            <p>フォームでのご相談申し込み</p>
          </div>
          <div class="topicContainer__contents">
            <p>こちらのフォームから、お客様情報のご入力をお願いします。ご相談日時を調整させていただき、返信いたします。</p>
            <div class="topicContainerButtons">
              <button @click="moveToContactForm()">ご相談申し込みはこちら</button>
            </div>
          </div>
        </div>
        <div class="topicContainer">
          <div class="topicContainer__title">
            <p>お電話でのお問い合わせ</p>
          </div>
          <div class="topicContainer__contents">
            <p>お急ぎの場合やお困りの場合は、お気軽にお電話ください。早急にご相談日時を調整させていただきます。</p>
            <div class="topicContainer__info">
              <a href="tel:0120654245"><img src="../../../../assets/images/h_tel.png"/></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import axios from 'axios'
  export default {
    name: 'CallModal',
    components: {},
    data() {
      return {
        careHome: null
      }
    },
    computed: {
      ...mapGetters('map', ['mapSelectedMarkerId']),
    },
    methods: {
      async fetchCareHome(){
        if(this.mapSelectedMarkerId != null){
          try {
            const res = await axios.get(`/map/api/care_homes/${this.mapSelectedMarkerId}`)
            this.careHome = res.data.care_home
          } catch(e) {
            alert('error')
          }
        }
      },
      hide() {
        this.$emit('hideModal')
      },
      async moveToContactForm(){
        await this.fetchCareHome()
        window.location.href = `https://3816a0c3.form.kintoneapp.com/public/sonaeru-hp-toiawase?naiyo=対面相談希望&sisetsu_mei=${this.careHome.name}`
      },
    },
  }
</script>
